import { SxProps, Theme } from '@mui/material';

export const heroScreenStyles = (theme: Theme, isTwoSided?: boolean): Record<string, SxProps> => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		minHeight: { xs: '80vh' },
		borderBottom: `2px solid ${theme.palette.primary.main}`,
	},
	background: {
		position: 'absolute',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		zIndex: '1',
	},
	foreground: {
		position: 'absolute',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		zIndex: '2',

		display: 'flex',
		flexDirection: isTwoSided ? { xs: 'column', lg: 'row' } : 'column',
		alignItems: isTwoSided ? 'stretch' : 'center',
		justifyContent: isTwoSided ? 'flex-start' : 'center',

		'& > *': isTwoSided
			? {
					flex: { xs: '1 1 auto', lg: '1 1 50%' },
			  }
			: {},
	},
});
